<template>
  <div class="vue-tempalte">
    <!-- Navigation -->
    <nav
      class="navbar shadow bg-white rounded justify-content-between flex-nowrap flex-row fixed-top"
    >
      <div class="container">
        <dropdownMenu dark-mode="auto">
          <section class="option">
            <router-link
              class="nav-link pr-3"
              title="nftstitches issued NFTs"
              to="/xrplnftmint"
              >Create NFT</router-link
            >
          </section>
          <section class="option">
            <router-link
              class="nav-link pr-3"
              title="Find NFT links to an NFT"
              to="/xrplnft"
              >Lookup NFTstitches</router-link
            >
          </section>
          <section class="option">
            <router-link
              class="nav-link pr-3"
              title="Specifications"
              to="/specifications"
              >Specifications</router-link
            >
          </section>
        </dropdownMenu>

        <router-link class="nav-link pr-3" to="/">
          <img src="@/assets/images/logo.png" width="55"
        /></router-link>
      </div>
    </nav>
    <!-- Main -->
    <div class="App">
      <div class="vertical-center">
        <div class="main-block">
          <router-view />
          <div>
            <hr />
            <h4>Copyright © 2023 NAPN LLC. All Rights Reserved</h4>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <cookie-law theme="dark-lime"></cookie-law>
    </footer>
  </div>
</template>

<script>
import dropdownMenu from "./components/vue-dropdown-menu";
import CookieLaw from "vue-cookie-law";

export default {
  components: {
    dropdownMenu,
    CookieLaw,
  },
};
</script>